import * as z from "zod";

export const getExchangeAddressLock = {
  name: "getExchangeAddressLock" as const,
  input: z.object({
    draftReturnId: z.string().nullish(),
    returnId: z.string().nullish(),
  }),
  output: z.object({
    lockedValues: z.object({ countryCode: z.string().nullish() }),
  }),
};
